/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewsletterSchemaOfferName
 */
export interface NewsletterSchemaOfferName {
    /**
     * 
     * @type {number}
     * @memberof NewsletterSchemaOfferName
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof NewsletterSchemaOfferName
     */
    name: string;
}

export function NewsletterSchemaOfferNameFromJSON(json: any): NewsletterSchemaOfferName {
    return NewsletterSchemaOfferNameFromJSONTyped(json, false);
}

export function NewsletterSchemaOfferNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewsletterSchemaOfferName {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function NewsletterSchemaOfferNameToJSON(value?: NewsletterSchemaOfferName | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}


